import { TextAreaProps } from 'antd/lib/input';
import { Controller, useFormContext } from 'react-hook-form';
import React, { RefObject, useRef } from 'react';
import ReactQuill from 'react-quill';
import './form.rich.text.editor.css';
import 'react-quill/dist/quill.snow.css';

interface FormInputProps extends TextAreaProps {
  name: string;
}

export const FormRichTextEditor = ({ name, defaultValue, onChange, ...props }: FormInputProps) => {
  const { control } = useFormContext();
  const reactQuillRef: RefObject<ReactQuill> = useRef<ReactQuill>(null);
  const formatOptions = ['bold', 'italic', 'underline', 'link'];

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <ReactQuill
            theme={'snow'}
            ref={reactQuillRef}
            value={value}
            onChange={onChange}
            placeholder={props.placeholder}
            readOnly={props.disabled}
            modules={{
              toolbar: formatOptions,
            }}
            formats={formatOptions}
          />
        )}
      />
      <div style={{ paddingTop: '50px' }}></div>
    </>
  );
};
